const REALWORLD_ADMIN_ROLE = 'RealWorld.Roles.Admin';
const REALWORLD_SCHOOL_ADMIN_ROLE = 'RealWorld.Roles.School.Admin';

const SCHOOL_ADMIN_ALLOWED_PLANS: ReadonlyArray<PlanType> = ['Class', 'Teacher'];

export function isRealworldAdminRole(role?: string | null) {
  return hasRole(role, REALWORLD_ADMIN_ROLE);
}

export function isSchoolAdminRole(role?: string | null) {
  return hasRole(role, REALWORLD_SCHOOL_ADMIN_ROLE);
}

export function isSchoolAdminAccessiblePlan(planType?: PlanType | null) {
  return Boolean(planType && SCHOOL_ADMIN_ALLOWED_PLANS.includes(planType));
}

function hasRole(role: string | null | undefined, expectedRole: string) {
  if (!role) return false;

  const normalizedRole = role.trim().toLowerCase();
  const normalizedExpectedRole = expectedRole.trim().toLowerCase();

  // Be resilient to different role serialization formats (single role, delimited string, etc).
  if (normalizedRole === normalizedExpectedRole) return true;
  if (normalizedRole.includes(normalizedExpectedRole)) return true;

  return normalizedRole
    .split(/[,\s|;]+/)
    .map((token) => token.trim())
    .filter(Boolean)
    .includes(normalizedExpectedRole);
}
